export default {
  name: "app-select",
  data() {
    return {
      choices: ""
    };
  },
  props: {
    modelValue: String,
    options: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    changeOption(event) {
      this.$emit("update:modelValue", event.target.value);
    }
  },
  mounted() {
    this.choices = new this.$Choices(this.$el, {
      searchEnabled: false,
      itemSelectText: ""
    });
  },
  beforeUnmount() {
    this.choices.destroy();
  }
};